module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Berikon-88e304ad4933ddf0bff8828ec09f59f1.svg";